export default __webpack_public_path__ + "static/media/iconHeadChair.aa52f7d7.svg";